module.exports = __webpack_public_path__ + "static/web-painting-1a-178378b9e33b5861d359167d4dc7d680.jpg";